export const AI_AGENT_SKILL_FILE_NAME = 'SKILL.md';
export const AI_AGENT_SKILL_RESOURCES_DIR = 'resources';
export const AI_AGENT_SKILL_NAME_MAX_LENGTH = 64;
// agentskills.io naming: lowercase letters, digits and single hyphens only.
export const AI_AGENT_SKILL_NAME_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
export const AI_AGENT_SKILL_RESERVED_NAME_PREFIX = 'lightdash-';
export const AI_AGENT_SKILL_DESCRIPTION_MAX_LENGTH = 1024;
export const AI_AGENT_SKILL_COMPATIBILITY_MAX_LENGTH = 500;
export const AI_AGENT_SKILL_BODY_MAX_BYTES = 64 * 1024;
export const AI_AGENT_SKILL_RESOURCE_MAX_BYTES = 64 * 1024;
export const AI_AGENT_SKILL_MAX_RESOURCES = 20;
export const AI_AGENT_SKILL_MAX_TOTAL_BYTES = 512 * 1024;
export const AI_AGENT_SKILL_BODY_WARN_LINES = 500;
export const AI_AGENT_SKILL_MAX_PER_AGENT = 50;
export const AI_AGENT_SKILL_LISTING_MAX_CHARS = 1536;
export const AI_AGENT_SKILLS_DISABLED_MESSAGE = 'Custom agent skills are not enabled';
//# sourceMappingURL=skillTypes.js.map